import axios from 'axios';
import axiosRetry from 'axios-retry';
import { DEFAULT_RETRY_STRATEGY, API_ROUTE } from '../constants';

export class Auth {
  constructor(retryStrategy = DEFAULT_RETRY_STRATEGY) {
    axiosRetry(axios, retryStrategy);
  }

  async fetchAuth(data) {
    const body = { quoteId: data.quoteId, zipCode: data.zipCode };
    const response = await axios.post('/api/auth/token', body);
    return response?.data;
  }

  async fetchQuoteData(quoteId, token) {
    const response = await axios.get(
      `${API_ROUTE.REACT_APP_SIMPLE_QUOTE_AUTH_URL}/${quoteId}`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `bearer ${token}`,
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      },
    );
    return response?.data;
  }
}
